import dateHelper from '../helpers/date-helper'

export function formatPacksForFront(data) {
  if (data.length > 0) {
    const packArray = []
    data.forEach((pack) => {
      packArray.push(formatPack(pack))
    })
    return packArray
  } else {
    return formatPack(data)
  }
}

function formatPack(data) {
  return {
    packId: data.packId,
    name: data.name,
    description: data.description,
    suitableFor: data.suitableFor,
    createdDate: dateHelper.formatGameDate(data.createdDate),
    tags: data.tags,
    rawActivityIds: data.rawActivityIds,
  }
}

export default {
  formatPacksForFront,
}
